import Alpine from 'alpinejs'
import { isMenuMobile } from '../utils/utils'

export const initHeader = (): void => {
    Alpine.data('header', () => ({
        headerClass: '',
        height: 0,
        lastScroll: 0,
        isSearchOpen: false,
        isMobile: isMenuMobile,
        isMenuOverlayOpen: false,
        scrollUp: false,
        scrollDown: false,
        inertElements: [] as HTMLElement[],
        init() {
            window.addEventListener('resize', () => this.calculateHeight())
            this.calculateHeight()

            this.inertElements = Array.from(
                document.querySelectorAll<HTMLElement>('#skip-container, #visible-header, main, footer')
            )
        },
        openMenuOverlay() {
            this.isMenuOverlayOpen = true

            document.querySelectorAll('.header__nav-link').forEach((element) => {
                element.addEventListener('focus', () => {
                    document
                        .querySelectorAll('.header__nav-item:not(:has(.header__nav-link:focus))')
                        .forEach((navItem) => {
                            navItem.classList.remove('active')
                            navItem.querySelector('.header__nav-submenu')?.classList.remove('active')
                        })
                })
            })

            setTimeout(() => {
                this.$refs.navHeader.focus()
            }, 100)

            this.setInert(true)
        },
        closeMenuOverlay() {
            this.isMenuOverlayOpen = false

            this.setInert(false)
        },
        handleScroll() {
            const currentScroll = window.scrollY

            if (currentScroll <= 0) {
                this.scrollUp = false
                this.scrollDown = false
                return
            }

            if (currentScroll > this.lastScroll && !this.scrollDown) {
                this.scrollDown = true
                this.scrollUp = false
            } else if (currentScroll < this.lastScroll && this.scrollDown) {
                this.scrollDown = false
                this.scrollUp = true
            }

            this.lastScroll = currentScroll
        },
        calculateHeight() {
            this.height = this.$el.offsetHeight
            document.body.style.setProperty('--header-height', `${this.height}px`)
        },
        setInert(enable: boolean) {
            this.inertElements.forEach((el: HTMLElement): void => {
                if (enable) {
                    el.setAttribute('inert', '')
                } else {
                    el.removeAttribute('inert')
                }
            })
        },
    }))
}
